/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */

export type IconTypeID = (typeof IconTypeID)[keyof typeof IconTypeID];

export const IconTypeID = {
  CATEGORY: 'category',
  RESOURCE: 'resource',
} as const;
